<template>
  <div class="content-wrap">
    <div class="container-fluid">
      <section id="main-content">
        <div id="currentDate">統計日期：{{time.today}}</div>
        <div class="cardGroup reportNowCs">
          <div class="row" v-if="filterDep.length > 0">
            <div :data-dep="dep.dep" class="col-lg-3" v-for="dep in filterDep" :key="dep.dep">
              <div class="card">
                <div class="stat-widget-one">
                  <div class="d-flex">
                    <div class="stat-text">{{dep.depName}}</div>
                    <div class="stat-digit d-flex">
                      <!-- <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>-->
                      {{dep.cs}} 件
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="reportNowTotal">
          <div class="row" v-if="filterDep.length > 0">
            <div :data-dep="dep.dep" class="col-lg-3" v-for="dep in filterDep" :key="dep.dep">
              <div class="card">
                <div class="stat-widget-two">
                  <div class="stat-content">
                    <div class="stat-text">目前總金額</div>
                    <div class="stat-digit">
                      <!-- <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>-->
                      {{dep.total}}
                    </div>
                  </div>
                  <div class="progress">
                    <div
                      :class="'progress-bar-'+mainColorObj[dep.dep].colorName"
                      class="animated progress-animated"
                      role="progressbar"
                      style="height:6px;width: 50%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 長條圖 -->
        <div class="reportNowTableGroup">
          <div class="row">
            <!-- <div data-dep="poster" class="col-lg-3">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table student-data-table">
                      <thead>
                        <tr>
                          <th colspan="2">審稿人</th>
                          <th>已key單</th>
                          <th>ftp抓檔</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div data-dep="card" class="col-lg-3">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table student-data-table">
                      <thead>
                        <tr>
                          <th colspan="2">審稿人</th>
                          <th>已key單</th>
                          <th>ftp抓檔</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div data-dep="ink" class="col-lg-3">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table student-data-table">
                      <thead>
                        <tr>
                          <th colspan="2">審稿人</th>
                          <th>已key單</th>
                          <th>ftp抓檔</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div data-dep="digit" class="col-lg-3">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table student-data-table">
                      <thead>
                        <tr>
                          <th colspan="2">審稿人</th>
                          <th>已key單</th>
                          <th>ftp抓檔</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>-->
            <div class="col-lg-3" v-for="(dep, i) in filterDetail" :key="i">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table student-data-table">
                      <thead>
                        <tr>
                          <th colspan="2">審稿人</th>
                          <th>已key單</th>
                          <th>ftp抓檔</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in dep" :key="item.gh_id">
                          <td class="placeflag" :style="'background-color:'+item.color"></td>
                          <td>{{item.name}}</td>
                          <td>{{item.cs}}</td>
                          <td>{{item.examValue}}</td>
                        </tr>
                        <tr v-if="sumDetailData.length !== 0">
                          <td class="placeflag highlight"></td>
                          <td>總件數</td>
                          <td>{{sumDetailData[i].cs}}</td>
                          <td>{{sumDetailData[i].examValue}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mainData: '',
      mainDataList: [],
      startDate: '',
      endDate: '',
      detailList: []
    };
  },
  props: {
    depAry: {
      type: Array,
      required: true
    },
    mainColorObj: {
      type: Object,
      required: true
    },
    time: {
      type: Object,
      required: true
    }
  },
  created() {
    let startDate = this.time.today;
    let endDate = new Date(startDate);
    endDate.setDate(endDate.getDate() + 1);
    let eYear = endDate.getFullYear();
    let eMonth = endDate.getMonth() + 1;
    let eDate = endDate.getDate();
    endDate = `${eYear}-${eMonth < 10 ? '0' + eMonth : eMonth}-${
      eDate < 10 ? '0' + eDate : eDate
    }`;
    this.startDate = startDate;
    this.endDate = endDate;
    $.ajax({
      url: './php/main.php',
      type: 'post',
      data: {
        function: 'GetInstantReportFun3',
        startDate: startDate,
        endDate: endDate,
        depAry: JSON.stringify(this.depAry)
      }
    }).done(res => {
      const data = JSON.parse(res);
      this.mainData = data;
      this.GetInstantReportFun2();
    });
  },
  computed: {
    filterDep() {
      if (!this.mainData) return [];
      return this.depAry.reduce((prev, next) => {
        let cs = this.mainData[next].cs * 1;
        let total = this.mainData[next].total;
        let depName = '海報';
        if (next == 'card') depName = '名片';
        if (next == 'ink') depName = '大圖';
        if (next == 'digit') depName = '數位';
        total = Math.floor(total)
          .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
          .slice(0, -3);
        let a = {
          dep: next,
          depName,
          cs,
          total
        };
        prev.push(a);
        return prev;
      }, []);
    },
    filterDetail() {
      if (this.detailList.lenght === 0) return [];
      return this.detailList.map(el => {
        return el.sort((a, b) => {
          return a.district - b.district > 0 ? 1 : -1;
        });
      });
    },
    sumDetailData() {
      if (this.detailList.lenght === 0) return [];
      return this.detailList.map(dep => {
        return dep.reduce(
          (prev, next) => {
            prev.cs += next.cs;
            prev.examValue += next.examValue - 0;
            return prev;
          },
          { cs: 0, examValue: 0 }
        );
      });
    }
  },
  methods: {
    GetInstantReportFun2() {
      $.ajax({
        url: './php/main.php',
        type: 'post',
        data: {
          function: 'GetInstantReportFun4',
          startDate: this.startDate,
          endDate: this.endDate,
          depAry: JSON.stringify(this.depAry)
        }
      }).done(res => {
        const data = JSON.parse(res);
        let ary = this.depAry.map(el => data[el]);
        this.detailList = ary.map(dep => {
          let { ftp, keyin } = dep;
          let newftp = ftp.reduce((prev, next) => {
            prev[next.gh_id] = {
              name: next.name,
              district: next.district,
              cs: next.examValue,
              id: next.gh_id
            };
            return prev;
          }, {});
          let newkeyin = keyin.reduce((prev, next) => {
            prev[next.gh_id] = {
              name: next.name,
              district: next.district,
              cs: next.cs,
              id: next.gh_id
            };
            return prev;
          }, {});
          let nameList = [];
          Object.keys(newftp).forEach(el =>
            nameList.indexOf(el) === -1 ? nameList.push(el) : ''
          );
          Object.keys(newkeyin).forEach(el =>
            nameList.indexOf(el) === -1 ? nameList.push(el) : ''
          );

          let obj = nameList.map((el, index) => {
            let childobj = {
              gh_id: el,
              name: newkeyin[el] ? newkeyin[el].name : newftp[el].name
            };
            childobj.examValue = newftp[el] ? newftp[el].cs : 0;
            childobj.cs = newkeyin[el] ? newkeyin[el].cs : 0;
            childobj.district = newftp[el]
              ? newftp[el].district
              : newkeyin[el].district;
            childobj.district =
              !childobj.district || childobj.district === 'OTHER'
                ? 4
                : childobj.district.split('-')[1] === '01' ||
                  childobj.district.split('-')[1] === '11'
                ? 2
                : childobj.district.split('-')[1] === '35' ||
                  childobj.district.split('-')[1] === '31'
                ? 1
                : 3;
            childobj.color =
              childobj.district === 1
                ? '#fbc524'
                : childobj.district === 2
                ? '#ff6aee'
                : childobj.district === 3
                ? '#3fc8dc'
                : '#ccc';

            return childobj;
          });
          return obj;
        });
      });
    }
  }
};
</script>

<style scoped>
.highlight {
  font-weight: bolder !important;
}
</style>
